import { useState } from "react";
import useToast from "../../../hooks/useToast";
import { useQuery } from "../../../hooks/useQuery";
import VolontariatPostuleForm from "./VolontariatPostuleForm";

const PostuleForm = () => {
  const { Toast, showToast } = useToast();
  const url = useQuery();
  const jobId = url.get("job_id");
  const [currentOffre,setCurrentOffre]=useState({});

  return (
    <>
      <Toast />
      <VolontariatPostuleForm />
    </>
  );
};

export default PostuleForm;
